/* eslint-disable max-len */
import { ICONS_ID } from '@bitComponents/unifiedIcons/SvgIconLoader';
import { CQ_ACTION_CODES } from '../../../catalogConstants';
import { STRING_KEYS } from '../../common';
import { USER_TYPE } from '../../../bitConstants/constants';

export const localizedStrings = {
  common: {
    everyMainSelection: {
      [STRING_KEYS.summary.title]: 'Hola {name}, completa tu pedido',
      [STRING_KEYS.summary.cart.manualOneTimeChargesTitle]: '',
      [STRING_KEYS.summary.cart.manualOneTimeChargesFinalPriceText]: 'Pago único contrareembolso',
      [STRING_KEYS.summary.cart.manualRecurringChargesFinalPriceText]: 'Cuota periódica',
      [STRING_KEYS.summary.cashOnDelivery.title]: 'Forma de pago saldo inicial tarjeta',
      [STRING_KEYS.summary.cashOnDelivery.text]: 'Contrarrembolso en efectivo.',
      [STRING_KEYS.summary.cashOnDelivery.secondaryText]: '',
      [STRING_KEYS.summary.prepaidActivation.title]: 'Activación tarjeta y recargas',
      [STRING_KEYS.summary.prepaidActivation.text]: 'Ten en cuenta que tendrás que activar la tarjeta y tener el saldo necesario cada 4 semanas para mantener la tarifa contratada.',
      [STRING_KEYS.summary.prepaidActivation.secondaryText]: ' Te enviaremos un mail indicándote como hacerlo.',
      [STRING_KEYS.provisionalAgreement.title]: '',
      [STRING_KEYS.provisionalAgreement.pdfLinkText]: 'Descarga del resumen del contrato (PDF).',
      [STRING_KEYS.payment.step.insertDirectDebit]: '',
      [STRING_KEYS.se.message.payment.sameAccount]: '',
      [STRING_KEYS.mainAction[CQ_ACTION_CODES.MIGRATION].multiplePhoneNumbers]: 'Quiero pasar un número Movistar a esta tarifa',
      [STRING_KEYS.mobileSecondaryAction[CQ_ACTION_CODES.MIGRATION].multiplePhoneNumbers]: 'Quiero pasar un número Movistar a esta tarifa',
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.TELCO}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.OPEN}`]: {
    everyMainSelection: {
      [STRING_KEYS.summary.title]: '',
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
}
